import IconArrowLeft from 'approot/shared/icons/icon-arrow-left';
import * as Styled from './pages-preview-pagination.style';

type Props = {
  currentPage: number;
  totalPageCount: number;
  isNext?: boolean;
  allyName?: string;
  id?: string;
  onClick: () => void;
};

const PagesPreviewPagination = ({
  currentPage,
  totalPageCount,
  isNext,
  allyName,
  id,
  onClick,
  ...rest
}: Props) => {
  return (
    <Styled.Pagination
      {...rest}
      id={id}
      type="button"
      $isNext={isNext}
      disabled={
        (isNext && currentPage + 1 === totalPageCount) ||
        (!isNext && currentPage === 0)
      }
      aria-label={`View page ${currentPage + 1}${
        allyName ? ` of ${allyName}` : ''
      }`}
      onClick={onClick}
      data-selector={
        isNext ? `icon-next-${currentPage + 1}` : `icon-previous-${currentPage}`
      }
    >
      <IconArrowLeft rotate={isNext ? 180 : 0} />
    </Styled.Pagination>
  );
};

export default PagesPreviewPagination;
